import {ConsumableCategory} from '@cypro/engine/database/schema'

export const EMPTY_CONSUMABLES_CATEGORIES: ConsumableCategory[] = [
  ConsumableCategory.enum.cassettes,
  ConsumableCategory.enum.emptyBags,
  ConsumableCategory.enum.pumps,
]
